import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import SEO, { buildBreadcrumbSchema } from '@/components/SEO';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const contactSchema = [
  buildBreadcrumbSchema([
    { name: 'Home', href: '/' },
    { name: 'Contact', href: '/contact' },
  ]),
  {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Contact Fore Capital',
  url: `${SITE_URL}/contact`,
  description: 'Get in touch with Fore Capital. Contact our team for payment infrastructure inquiries, partnerships, or support.',
  mainEntity: {
    '@type': 'Organization',
    name: 'Fore Capital',
    url: SITE_URL,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Support',
      availableLanguage: 'English',
    },
  },
  },
];

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#F9F9F7]" style={{ fontFamily: "'Google Sans Flex', sans-serif" }}>
      <SEO
        title="Contact Fore Capital | Get in Touch"
        description="Get in touch with Fore Capital. Contact our team for payment infrastructure inquiries, partnerships, or support."
        keywords="contact Fore Capital, payment support, merchant services contact, fintech contact"
        pathname="/contact"
        schema={contactSchema}
      />
      <Navbar />
      <main>
        <ContactHero />
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-28">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 lg:gap-20">
            <div className="lg:col-span-3">
              <ContactForm />
            </div>
            <div className="lg:col-span-2">
              <ContactInfo />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}